import { Badge } from "@/components/ui/badge";
import { getStatusBadge } from "@/utils/helpers";

type Props = {
  value?: string | null;
};

/** Incoming (green) / Outgoing (blue) pills — same badge pattern as patient type. */
export function ConflictCallTypeBadge({ value }: Props) {
  const raw = String(value ?? "").trim();
  if (!raw) return <span className="text-muted-foreground">—</span>;

  const normalized = raw.toLowerCase();
  const isInbound = normalized === "inbound";
  const label =
    isInbound
      ? "inbound"
      : normalized === "incoming"
        ? "Incoming"
        : normalized === "outgoing"
          ? "Outgoing"
          : raw;
  const colors = getStatusBadge(isInbound ? "Incoming" : label);

  return (
    <Badge
      variant="outline"
      className={`rounded-full px-5 py-1 teachers capitalize`}
      style={{
        backgroundColor: colors.bgColor,
        color: colors.mainColor,
        borderColor: colors.mainColor,
      }}
    >
      {label}
    </Badge>
  );
}
